import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { onMounted } from 'vue';
import { getvisits } from './api/index';
import { ElMessage } from 'element-plus';
import cookie from 'js-cookie';
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {
    onMounted(() => {
      if (!cookie.get('visits')) {
        getvisits().then(res => {
          const now = new Date();
          now.setMinutes(now.getMinutes() + 60);
          cookie.set('visits', res.visits, {
            Expires: now.toUTCString()
          });
        });
      }
      ElMessage({
        type: 'info',
        message: '此版本不是最终版本，最终版本还在开发中',
        duration: 1000
      });
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createBlock(_component_router_view);
    };
  }
});